//authentication
export const LOGIN = 'LOGIN'
export const LOGOUT = 'LOGOUT'
export const AUTH_ERROR = 'AUTH_ERROR'
export const GET_USER = 'GET_USER'
export const PROFILE_PICTURE = 'PROFILE_PICTURE'

// departments
export const GET_DEPARTMENTS = 'GET_DEPARTMENTS'
export const ADD_DEPARTMENT = 'ADD_DEPARTMENT'
export const UPDATE_DEPARTMENT = 'UPDATE_DEPARTMENT'
export const DELETE_DEPARTMENT = 'DELETE_DEPARTMENT'
export const DEPARTMENT_ERROR = 'DEPARTMENT_ERROR'
export const SELECT_DEPARTMENTS = 'SELECT_DEPARTMENTS'
export const SELECT_DEPARTMENTS_USER = 'SELECT_DEPARTMENTS_USER'
export const SELECT_DEPARTMENTS_EMPLOYEE = 'SELECT_DEPARTMENTS_EMPLOYEE'

// banks
export const GET_BANKS = 'GET_BANKS'
export const GET_BANK = 'GET_BANK'
export const ADD_BANK = 'ADD_BANK'
export const UPDATE_BANK = 'UPDATE_BANK'
export const DELETE_BANK = 'DELETE_BANK'
export const BANK_ERROR = 'BANK_ERROR'
export const EXPORT_BANK_EXCEL = 'EXPORT_BANK_EXCEL'
export const SELECT_BANKS = 'SELECT_BANKS'

// providers
export const GET_PROVIDERS = 'GET_PROVIDERS'
export const GET_PROVIDER = 'GET_PROVIDER'
export const ADD_PROVIDER = 'ADD_PROVIDER'
export const UPDATE_PROVIDER = 'UPDATE_PROVIDER'
export const DELETE_PROVIDER = 'DELETE_PROVIDER'
export const PROVIDER_ERROR = 'PROVIDER_ERROR'
export const EXPORT_PROVIDER_EXCEL = 'EXPORT_PROVIDER_EXCEL'
export const SELECT_PROVIDERS = 'SELECT_PROVIDERS'
export const SELECT_ACCOUNT_PROVIDERS = 'SELECT_ACCOUNT_PROVIDERS'
export const DELETE_PROVIDER_ACCOUNT = 'DELETE_PROVIDER_ACCOUNT'

//quotes
export const GET_QUOTES = 'GET_QUOTES'
export const GET_QUOTE = 'GET_QUOTE'
export const ADD_QUOTE = 'ADD_QUOTE'
export const UPDATE_QUOTE = 'UPDATE_QUOTE'
export const DELETE_QUOTE = 'DELETE_QUOTE'
export const EXPORT_QUOTE_EXCEL = 'EXPORT_QUOTE_EXCEL'
export const QUOTE_ERROR = 'QUOTE_ERROR'
export const GET_QUOTE_OBSERVATIONS = 'GET_QUOTE_OBSERVATIONS'
export const ADD_QUOTE_OBSERVATION = 'ADD_QUOTE_OBSERVATION'
export const SEND_PAY_QUOTE = 'SEND_PAY_QUOTE'
export const SEND_PROVIDER_QUOTE = 'SEND_PROVIDER_QUOTE'

//quotesProvider
export const GET_QUOTES_PROVIDER = 'GET_QUOTES_PROVIDER'
export const QUOTE_ERROR_PROVIDER = 'QUOTE_ERROR_PROVIDER'

// QuoteFiles
export const UPLOAD_QUOTE_FILE_PROGRESS = 'UPLOAD_QUOTE_FILE_PROGRESS'
export const UPLOAD_QUOTE_FILE = 'UPLOAD_QUOTE_FILE'
export const FILE_QUOTE_ERROR = 'FILE_QUOTE_ERROR'

//quoteConcepts
export const GET_QUOTE_CHARGES = 'GET_QUOTE_CHARGES'
export const GET_QUOTE_CONCEPTS = 'GET_QUOTE_CONCEPTS'
export const QUOTE_CONCEPT_ERROR = 'QUOTE_CONCEPT_ERROR'
export const EXPORT_QUOTE_MONTH_EXCEL = 'EXPORT_QUOTE_MONTH_EXCEL'

//units
export const GET_UNIT_LINES = 'GET_UNIT_LINES'
export const GET_UNITS = 'GET_UNITS'
export const GET_PROJECT_UNITS = 'GET_PROJECT_UNITS'
export const ADD_PROJECT_UNIT = 'ADD_PROJECT_UNIT'
export const UNIT_ERROR = 'UNIT_ERROR'

//purchaseRequest
export const GET_PURCHASE_REQUESTS = 'GET_PURCHASE_REQUESTS'
export const GET_PURCHASE_REQUEST = 'GET_PURCHASE_REQUEST'
export const ADD_PURCHASE_REQUEST = 'ADD_PURCHASE_REQUEST'
export const UPDATE_PURCHASE_REQUEST = 'UPDATE_PURCHASE_REQUEST'
export const DELETE_PURCHASE_REQUEST = 'DELETE_PURCHASE_REQUEST'
export const PURCHASE_REQUEST_ERROR = 'PURCHASE_REQUEST_ERROR'
export const GET_PURCHASE_REQUEST_OBSERVATIONS = 'GET_PURCHASE_REQUEST_OBSERVATIONS'
export const ADD_PURCHASE_REQUEST_OBSERVATION = 'ADD_PURCHASE_REQUEST_OBSERVATION'
export const EXPORT_PURCHASE_REQUEST_EXCEL = 'EXPORT_PURCHASE_REQUEST_EXCEL'

//pendingPayments
export const GET_PENDING_PAYMENTS = 'GET_PENDING_PAYMENTS'
export const PENDING_PAYMENTS_ERROR = 'PENDING_PAYMENTS_ERROR'

//paymentsWithoutInvoice
export const GET_PAYMENTS_WITHOUT_INVOICE = 'GET_PAYMENTS_WITHOUT_INVOICE'
export const UPDATE_PAYMENT_WITHOUT_INVOICE = 'UPDATE_PAYMENT_WITHOUT_INVOICE'
export const PAYMENTS_WITHOUT_INVOICE_ERROR = 'PAYMENTS_WITHOUT_INVOICE_ERROR'
export const GET_PAYMENTS_WITHOUT_INVOICE_OBSERVATIONS = 'GET_PAYMENTS_WITHOUT_INVOICE_OBSERVATIONS'

//myPayments
export const GET_MY_PAYMENTS = 'GET_MY_PAYMENTS'
export const MY_PAYMENTS_ERROR = 'MY_PAYMENTS_ERROR'

// files
export const GET_FILES = 'GET_FILES'
export const DOWNLOAD_FILE = 'DOWNLOAD_FILE'
export const UPLOAD_FILE = 'UPLOAD_FILE'
export const UPLOAD_FILE_PROGRESS = 'UPLOAD_FILE_PROGRESS'
export const UPDATE_FILE = 'UPDATE_FILE'
export const DELETE_FILE = 'DELETE_FILE'
export const FILE_ERROR = 'FILE_ERROR'

// users
export const GET_USERS = 'GET_USERS'
export const GET_USERS_PROVIDERS = 'GET_USERS_PROVIDERS'
export const ADD_USER = 'ADD_USER'
export const ADD_USER_PROVIDER = 'ADD_USER_PROVIDER'
export const UPDATE_USER_PROVIDER = 'UPDATE_USER_PROVIDER'
export const DELETE_USER_PROVIDER = 'DELETE_USER_PROVIDER'
export const UPDATE_USER = 'UPDATE_USER'
export const DELETE_USER = 'DELETE_USER'
export const ASSIGN_MODULE_USER = 'ASSIGN_MODULE_USER'
export const ASSIGN_PERMISSION_USER = 'ASSIGN_PERMISSION_USER'
export const GET_RECEIVERS = 'GET_RECEIVERS'
export const USER_ERROR = 'USER_ERROR'

// permissions
export const GET_PERMISSIONS = 'GET_PERMISSIONS'
export const PERMISSION_ERROR = 'PERMISSION_ERROR'

// roles
export const GET_ROLES = 'GET_ROLES'
export const ROLE_ERROR = 'ROLE_ERROR'
export const SELECT_ROLES = 'SELECT_ROLES'

//dropbox
export const GET_AUTHORIZATION_CODE = 'GET_AUTHORIZATION_CODE'
export const DROPBOX_ERROR = 'DROPBOX_ERROR'

// payed payments
export const GET_PAYED_PAYMENTS = 'GET_PAYED_PAYMENTS'
export const PAYED_PAYMENTS_ERROR = 'PAYED_PAYMENTS_ERROR'
export const GET_PAYED_PAYMENTS_OBSERVATIONS = 'GET_PAYED_PAYMENTS_OBSERVATIONS'
export const CREDIT_PURCHASE_REQUEST = 'CREDIT_PURCHASE_REQUEST'
export const APPROVE_PAYMENT_PR = 'APPROVE_PAYMENT_PR'
export const AUTHORIZE_PAYMENT_PR = 'AUTHORIZE_PAYMENT_PR'
export const PAY_PAYMENT_PR = 'PAY_PAYMENT_PR'

// cancelled payments
export const GET_CANCELLED_PAYMENTS = 'GET_CANCELLED_PAYMENTS'
export const CANCELLED_PAYMENTS_ERROR = 'CANCELLED_PAYMENTS_ERROR'
export const GET_CANCELLED_PAYMENTS_OBSERVATIONS = 'GET_CANCELLED_PAYMENTS_OBSERVATIONS'

// projects
export const GET_PROJECTS = 'GET_PROJECTS'
export const GET_PROJECT = 'GET_PROJECT'
export const ADD_PROJECT = 'ADD_PROJECT'
export const UPDATE_PROJECT = 'UPDATE_PROJECT'
export const DELETE_PROJECT = 'DELETE_PROJECT'
export const PROJECT_ERROR = 'PROJECT_ERROR'
export const EXPORT_PROJECT_EXCEL = 'EXPORT_PROJECT_EXCEL'
export const ADD_PROJECT_BUDGET = 'ADD_PROJECT_BUDGET'

//provider quotes
export const PROVIDER_QUOTE_ERROR = 'PROVIDER_QUOTE_ERROR'
export const GET_PROVIDERS_QUOTE = 'GET_PROVIDERS_QUOTE'
export const GET_PROVIDER_QUOTES = 'GET_PROVIDER_QUOTES'

//charges
export const CHARGE_ERROR = 'CHARGE_ERROR'
export const GET_CHARGES = 'GET_CHARGES'
export const DELETE_CHARGE = 'DELETE_CHARGE'
export const ADD_CHARGE = 'ADD_CHARGE'
export const UPDATE_CHARGE = 'UPDATE_CHARGE'

//budgets
export const BUDGET_ERROR = 'BUDGET_ERROR'
export const GET_BUDGETS = 'GET_BUDGETS'
export const DELETE_BUDGET = 'DELETE_BUDGET'
export const ADD_BUDGET = 'ADD_BUDGET'
export const UPDATE_BUDGET = 'UPDATE_BUDGET'
export const EXPORT_BUDGETS_TEMPLATE_EXCEL = 'EXPORT_BUDGETS_TEMPLATE_EXCEL'
export const IMPORT_BUDGETS_TEMPLATE_EXCEL = 'IMPORT_BUDGETS_TEMPLATE_EXCEL'
export const IMPORT_BUDGETS_TEMPLATE_EXCEL_PROGRESS = 'IMPORT_BUDGETS_TEMPLATE_EXCEL_PROGRESS'
export const EXPORT_BUDGET_EXCEL = 'EXPORT_BUDGET_EXCEL'

//contracts
export const GET_CONTRACTS = 'GET_CONTRACTS'
export const GET_CONTRACT = 'GET_CONTRACT'
export const ADD_CONTRACT = 'ADD_CONTRACT'
export const UPDATE_CONTRACT = 'UPDATE_CONTRACT'
export const DELETE_CONTRACT = 'DELETE_CONTRACT'
export const SEND_PROVIDER_CONTRACT = 'SEND_PROVIDER_CONTRACT'
export const EXPORT_CONTRACT_EXCEL = 'EXPORT_CONTRACT_EXCEL'
export const CONTRACT_ERROR = 'CONTRACT_ERROR'
export const GET_PAYMENTS_CONTRACT = 'GET_PAYMENTS_CONTRACT'
export const ADD_PAYMENT_CONTRACT = 'ADD_PAYMENT_CONTRACT'
export const UPDATE_PAYMENT_CONTRACT = 'UPDATE_PAYMENT_CONTRACT'

//sync nominas
export const GET_NOM_SYNC = 'GET_NOM_SYNC'
export const NOM_ERROR = 'NOM_ERROR'

// currency exchange
export const SET_EXCHANGE_RATE = 'SET_EXCHANGE_RATE'
export const LOADING_EXCHANGE_RATE = 'LOADING_EXCHANGE_RATE'
export const EXCHANGE_RATE_ERROR = 'EXCHANGE_RATE_ERROR'

// dashboard
export const GET_DASHBOARD_MESSAGE = 'GET_DASHBOARD_MESSAGE'
export const UPDATE_DASHBOARD_MESSAGE = 'UPDATE_DASHBOARD_MESSAGE'
export const CONFIGURATION_ERROR = 'CONFIGURATION_ERROR'

//DH
export const GET_LEGAL_NAMES = 'GET_LEGAL_NAMES'
export const LEGAL_NAMES_ERROR = 'LEGAL_NAMES_ERROR'
export const GET_POSITIONS = 'GET_POSITIONS'
export const GET_POSITION = 'GET_POSITION'
export const ADD_POSITION = 'ADD_POSITION'
export const UPDATE_POSITION = 'UPDATE_POSITION'
export const DELETE_POSITION = 'DELETE_POSITION'
export const POSITION_ERROR = 'POSITION_ERROR'
export const EXPORT_POSITION_EXCEL = 'EXPORT_POSITION_EXCEL'
export const SELECT_POSITIONS = 'SELECT_POSITIONS'

// vacations
export const GET_VACATIONS = 'GET_VACATIONS'
export const GET_VACATION = 'GET_VACATION'
export const GET_VACATIONS_DASHBOARD = 'GET_VACATIONS_DASHBOARD'
export const ADD_VACATION = 'ADD_VACATION'
export const UPDATE_VACATION = 'UPDATE_VACATION'
export const DELETE_VACATION = 'DELETE_VACATION'
export const VACATION_ERROR = 'VACATION_ERROR'
export const GET_VACATION_CONTROL = 'GET_VACATION_CONTROL'
export const VACATION_CONTROL_ERROR = 'VACATION_CONTROL_ERROR'
export const EXPORT_VACATION_CONTROL_EXCEL = 'EXPORT_VACATION_CONTROL_EXCEL'

// employees
export const GET_EMPLOYEES = 'GET_EMPLOYEES'
export const GET_EMPLOYEE = 'GET_EMPLOYEE'
export const ADD_EMPLOYEE = 'ADD_EMPLOYEE'
export const UPDATE_EMPLOYEE = 'UPDATE_EMPLOYEE'
export const DELETE_EMPLOYEE = 'DELETE_EMPLOYEE'
export const EMPLOYEE_ERROR = 'EMPLOYEE_ERROR'
export const EXPORT_EMPLOYEE_EXCEL = 'EXPORT_EMPLOYEE_EXCEL'
export const SELECT_EMPLOYEES = 'SELECT_EMPLOYEES'

// holidays
export const GET_HOLIDAYS = 'GET_HOLIDAYS'
export const GET_HOLIDAY = 'GET_HOLIDAY'
export const ADD_HOLIDAY = 'ADD_HOLIDAY'
export const UPDATE_HOLIDAY = 'UPDATE_HOLIDAY'
export const DELETE_HOLIDAY = 'DELETE_HOLIDAY'
export const HOLIDAY_ERROR = 'HOLIDAY_ERROR'
